import { SxProps, Theme } from "@mui/material";
import { CSSProperties } from "react";

export const root: (actionStyles: CSSProperties) => SxProps<Theme> = (
  actionStyles
) => ({
  ...actionStyles,
  cursor: "grab",
});
